import { VaultInput as VgsInput } from "@snap-mobile/vault";
import React, { useEffect, useState } from "react";

type VaultInputProps = {
  name: string;
  label?: string;
  type: React.ComponentProps<typeof VgsInput>["type"];
  placeholder?: string;
  helpText?: string;
  onValid?: React.ComponentProps<typeof VgsInput>["onValid"];
  required?: boolean;
};

export default function VaultInput({
  name,
  label,
  placeholder,
  type,
  helpText,
  onValid,
  required,
}: VaultInputProps) {
  const [isValid, setIsValid] = useState(true);
  const [isEmpty, setIsEmpty] = useState(true);
  const [isDirty, setIsDirty] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string>();

  useEffect(() => {
    if (isDirty && !isValid && !isEmpty) {
      setErrorMessage("Field is not valid");
      if (onValid) {
        onValid(false);
      }
    }
  }, [isValid, isDirty, isEmpty, onValid]);
  useEffect(() => {
    if (isEmpty && required && isDirty) {
      setErrorMessage("Field is Required");
      if (onValid) {
        onValid(false);
      }
    } else if (!isEmpty && required && errorMessage === "Field is Required") {
      setErrorMessage(undefined);
      if (onValid) {
        onValid(true);
      }
    }
  }, [errorMessage, isDirty, isEmpty, onValid, required]);
  useEffect(() => {
    if (isValid) {
      if (onValid) {
        onValid(isValid);
      }
      setErrorMessage(undefined);
    }
  }, [isValid, onValid]);

  return (
    <>
      {label && (
        <label
          htmlFor={name}
          className="text-gray-800 block text-sm font-medium leading-5"
        >
          {label} {required && <span className="text-red-600">*</span>}
        </label>
      )}
      <div className="mt-2">
        <VgsInput
          name={name}
          placeholder={placeholder}
          type={type}
          style={{
            border: `1px solid ${errorMessage ? "red" : "#CBD5E1"}`,
            borderRadius: "0.625rem",
            lineHeight: "1.5rem",
            padding: "0.5rem 0.75rem",
            "&::placeholder": {
              color: "#9CA3AF",
            },
            "&:focus": {
              border: `2px solid ${
                errorMessage ? "red" : "#2563EB"
              } !important`,
            },
          }}
          onValid={(validValue: boolean) => {
            setIsValid(validValue);
            if (onValid) {
              onValid(validValue);
            }
          }}
          onEmpty={setIsEmpty}
          onDirty={setIsDirty}
        />
      </div>
      {helpText && (
        <span className="text-gray-500 text-sm leading-5">{helpText}</span>
      )}
      {errorMessage && (
        <span className="text-red-500 text-sm leading-5">{errorMessage}</span>
      )}
    </>
  );
}
